import { render, staticRenderFns } from "./loans.vue?vue&type=template&id=7339ff3f"
import script from "./loans.vue?vue&type=script&lang=js"
export * from "./loans.vue?vue&type=script&lang=js"
import style0 from "./loans.vue?vue&type=style&index=0&id=7339ff3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports